import React from "react";
import {Box, Button, Paper, Stack, TextField, Tooltip, Typography} from "@mui/material";
import {useNavigate} from "react-router-dom";
import {useNotification} from "../../utils/hooks/useNotification";
import {useForm} from "react-hook-form";
import {zodResolver} from "@hookform/resolvers/zod";
import {seasonCreateSchema, SeasonCreateSchema} from "../../schemas/seasons/seasonCreateSchema";
import {postFetcher} from "../../utils/api/fetchers";
import {Season} from "../../schemas/seasons/seasonsSchema";

const Seasons: React.FC = () => {
    const navigate = useNavigate();
    const {showNotification} = useNotification();
    const {register, handleSubmit, formState: {errors}} = useForm<SeasonCreateSchema>({
        resolver: zodResolver(seasonCreateSchema),
    });

    const onSubmit = async (data: SeasonCreateSchema) => {
        postFetcher<SeasonCreateSchema, Season>("/seasons", data)
            .then(() => {
                showNotification("Sezóna byla úspěšně vytvořena", "success");
                navigate('/seasons');
            })
            .catch((error) => {
                if (error.response?.status === 409) {
                    showNotification("Sezóna s tímto rokem již existuje", "error");
                    return
                }
                showNotification("Sezónu se nepodařilo vytvořit", "error");
            });
    };

    return (
        <Paper elevation={3} sx={{padding: 4, maxWidth: 600, margin: '0 auto'}}>
            <Typography variant="h4" gutterBottom>
                Vytvoření sezóny
            </Typography>
            <Box component="form" noValidate onSubmit={handleSubmit(onSubmit)}>
                <Stack spacing={3}>
                    <TextField
                        autoFocus
                        fullWidth
                        label="Rok"
                        variant="standard"
                        type="number"
                        required
                        {...register('year', {
                            valueAsNumber: true
                        })}
                        error={!!errors.year}
                        helperText={errors.year?.message}
                        inputProps={{min: 2000, max: 2100}}
                        defaultValue={new Date().getFullYear() + 1}
                    />
                    <Tooltip title="Počet závodů, které se budou počítat do celkového pořadí pro jednotilvé kategorie"
                             placement="top" arrow>
                        <TextField
                            fullWidth
                            label="Počet započítaných závodů"
                            variant="standard"
                            type="number"
                            required
                            {...register('numberOfCountedRaces', {
                                valueAsNumber: true
                            })}
                            error={!!errors.numberOfCountedRaces}
                            helperText={errors.numberOfCountedRaces?.message}
                            inputProps={{min: 1, max: 100}}
                        />
                    </Tooltip>
                    <Button type="submit" variant="contained" color="primary" fullWidth>
                        Vytvořit sezónu
                    </Button>
                </Stack>
            </Box>
        </Paper>
    );
}

export default Seasons;